import "./saved.css";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import { CartContext } from "../../../../../contexts/cartContext";
import apiBusiness from "../../../../../../utils/apiBusiness";
import ToastNote from "../../../../../golbal/notifications/toastNote";
import { CircularProgress } from "@mui/material";
import api from "../../../../../../utils/api";
import ColoredSpiner from "../../../../../alret/spiners/coloredSpiner/coloredSpinner";
import MyIcons from "../../../../../golbal/icons/myIcons";

export default function SavedBusiness() {
  const messageRef = useRef(null);
  const [loading, setLoading] = useState({
    spinner: false,
    id: "",
    loading2: false,
    loading3: false,
  });

  const { user, signedUser } = useContext(CartContext);
  const [countryShort, stateShort] = window.location.pathname
    .toLowerCase()
    .split("/")
    .slice(2, 4);

  const navigate = useNavigate();
  console.log(user);
  const url = useParams();
  // console.log(url);
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchSavedList();
  }, []);

  async function fetchSavedList() {
    setLoading((pre) => ({ ...pre, spinner: true }));
    const response = await apiBusiness.userSavedList({
      token: user.token,
      savedItems: user?.saved?.business,
    });
    setLoading((pre) => ({ ...pre, spinner: false }));
    console.log(response.data);
    if (response.error)
      return messageRef.current.showError({ message: response.error });
    setData(response.data);
  }

  const deleteHandler = async (e, business) => {
    e.preventDefault();
    const text = "شما در حال حذف این کسب و کار از ذخیره میباشید.";
    if (window.confirm(text) != true) return;
    setLoading((pre) => ({
      ...pre,
      id: business._id,
    }));
    const response = await api.saveHandler({
      id: business._id,
      token: user.token,
      section: "business",
    });
    setLoading((pre) => ({ ...pre, id: "" }));
    if (response.error)
      return messageRef.current.showError({ message: response.error });
    messageRef.current.showWarning({
      message: "کسب و کار از لیست ذخیره حذف شد.",
    });
    signedUser(response.data);
    const newData = data.filter((da) => da._id !== business._id);
    setData(newData);
  };

  function showPageHandle(props) {
    let text = "";
    if (window.lang !== props.businessLng.toLowerCase())
      text += `شما در حال انتقال به زبان ${window.capitalize(
        props.businessLng
      )} میباشد . \n`;
    if (countryShort.toLowerCase() !== props.countryShort.toLowerCase())
      text += `شما در حال انتقال به کشور ${window.capitalize(
        props.country
      )} میباشد . \n`;
    if (stateShort.toLowerCase() !== props.stateShort.toLowerCase())
      text += `شما در حال انتقال به استان ${window.capitalize(
        props.state
      )} میباشد . \n`;
    if (!text.length)
      return navigate(`/${window.lang}/business/page/${props._id}`);
    if (window.confirm(text) != true) return;
    console.log("Passed");
    navigate(
      `/${
        props.businessLng + "/" + props.countryShort + "/" + props.stateShort
      }/business/page/${props._id}`
    );
  }

  const columns = [
    {
      field: "action",
      headerName: "عملیات",
      width: 150,
      renderCell: (params) => {
        return (
          <div className="d-flex">
            <div title="نمایش" onClick={(e) => showPageHandle(params.row)}>
              <MyIcons icon="display" />{" "}
            </div>
            {loading.id === params.row._id ? (
              <CircularProgress color="inherit" size="20px" />
            ) : (
              <div
                title="پاک کردن"
                onClick={(e) => deleteHandler(e, params.row)}
              >
                <MyIcons icon="delete2" />
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: "businessCard",
      headerName: "عکس",
      width: 100,
      renderCell: (params) => {
        return (
          <div>
            <img
              src={params.row.businessCard}
              alt="businessCard"
              className="userListImg"
              loading="lazy"
            />
          </div>
        );
      },
    },
    {
      field: "busName",
      headerName: "نام کسب و کار",
      width: 150,
      renderCell: (params) => {
        return (
          <div className="userListEdit">
            <div title={params.row?.busName?.[window.lang]}>
              {params.row?.busName?.[window.lang]}
            </div>
            {/* <div title={params.row?.email}> {params.row?.email}</div>        */}
          </div>
        );
      },
    },
    {
      field: "subCategory",
      headerName: "دسته بندی",
      width: 100,
    },
    {
      field: "city",
      headerName: "شهر",
      width: 100,
      renderCell: (params) => (
        <div dir="ltr" title={params.row?.city}>
          {window.capitalize(params.row?.city)}
        </div>
      ),
    },
    {
      field: "state",
      headerName: "استان",
      width: 100,
      renderCell: (params) => (
        <div dir="ltr" title={params.row?.state}>
          {window.capitalize(params.row?.state)}
        </div>
      ),
    },
    {
      field: "country",
      headerName: "کشور",
      width: 100,
      renderCell: (params) => (
        <div dir="ltr" title={params.row?.country}>
          {window.capitalize(params.row?.country)}
        </div>
      ),
    },
  ];

  return (
    <div className="userList" style={{ height: "100vh", width: "100%" }}>
      Saved Business
      {loading.spinner && <ColoredSpiner />}
      <ToastNote messageRef={messageRef} />
      <DataGrid
        getRowId={(row) => row._id}
        rows={data}
        components={{
          Toolbar: GridToolbar,
        }}
        disableSelectionOnClick
        columns={columns}
        pageSize={[15]}
        rowsPerPageOptions={[1]}
        checkboxSelection
      />
    </div>
  );
}
